var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn-toggle',{attrs:{"value":_vm.selectedButtons,"multiple":"","dense":""}},_vm._l((_vm.buttons),function(button){return _c('v-btn',{key:button.key,class:{'custom-disabled': _vm.disabled},attrs:{"active-class":button.activeClass},on:{"click":function($event){return _vm.getClicked(button.key)}}},[_vm._v(" "+_vm._s(button.value)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }